export default __webpack_public_path__ + "static/media/foundation_popupImg2.0d714624.png";